import { m } from 'framer-motion';
import PropTypes from 'prop-types';

import { IconButton } from '@mui/material';
import Badge, { badgeClasses } from '@mui/material/Badge';

import { varHover } from 'src/components/animate';
import { useSettingsContext } from 'src/components/settings';

import SvgColor from '../../components/svg-color/index';

// ----------------------------------------------------------------------

export default function DarkModeButton({ sx }) {
  const settings = useSettingsContext();

  const modes = ['light', 'dark', 'system'];
  const labels = { light: 'Giorno', dark: 'Notte', system: 'Automatico' };
  const icons = { light: 'sun', dark: 'moon', system: 'system' };
  const mode = settings.themeModePreference;
  const nextMode = modes[(modes.indexOf(mode) + 1) % modes.length];
  const label = `Tema: ${labels[mode]}. Passa a ${labels[nextMode]}`;

  return (
    <Badge
      color="error"
      variant="dot"
      // invisible={!settings.canReset}
      invisible
      sx={{
        [`& .${badgeClasses.badge}`]: {
          top: 8,
          right: 8,
        },
        ...sx,
      }}
    >
      <IconButton
        component={m.button}
        whileTap="tap"
        whileHover="hover"
        variants={varHover(1.05)}
        aria-label={label}
        title={label}
        onClick={() => {
          settings.onUpdate(
            'themeMode',
            nextMode
          );
        }}
        sx={{
          width: 40,
          height: 40,
        }}
      >
        <SvgColor
          src={`/assets/icons/setting/ic_${
            icons[mode]
          }.svg`}
        />
      </IconButton>
    </Badge>
  );
}

DarkModeButton.propTypes = {
  sx: PropTypes.object,
};
